import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// 导入 Vant 组件
import { 
  Button, 
  NavBar, 
  Tabbar, 
  TabbarItem, 
  Grid, 
  GridItem, 
  Image as VanImage, 
  Card, 
  Tag, 
  Cell, 
  CellGroup, 
  Icon, 
  Popup, 
  Overlay, 
  Loading, 
  Toast, 
  Dialog, 
  ActionSheet, 
  Picker, 
  Field, 
  Form, 
  Checkbox, 
  CheckboxGroup, 
  Radio, 
  RadioGroup, 
  Stepper, 
  Rate, 
  Slider, 
  Switch, 
  Uploader, 
  DatetimePicker, 
  Calendar, 
  Cascader, 
  PasswordInput, 
  NumberKeyboard, 
  Search, 
  Tabs, 
  Tab, 
  Sticky, 
  Swipe, 
  SwipeItem, 
  NoticeBar, 
  CountDown, 
  Steps, 
  Step, 
  Divider, 
  Empty, 
  List, 
  PullRefresh, 
  BackTop, 
  Skeleton, 
  SkeletonTitle, 
  SkeletonImage, 
  SkeletonAvatar, 
  SkeletonParagraph, 
  Lazyload, 
  ImagePreview, 
  ShareSheet, 
  DropdownMenu, 
  DropdownItem, 
  Sidebar, 
  SidebarItem, 
  TreeSelect, 
  ContactCard, 
  ContactList, 
  ContactEdit, 
  Area, 
  AddressList, 
  AddressEdit, 
  Goods, 
  GoodsAction, 
  GoodsActionIcon, 
  GoodsActionButton, 
  SubmitBar, 
  Sku, 
  Coupon, 
  CouponCell, 
  CouponList 
} from 'vant'

// 导入 Vant 样式
import 'vant/lib/index.css'

const app = createApp(App)

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info)
  Toast.fail('System error, please try again later')
}

// 注册 Vant 组件
app.use(Button)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Grid)
app.use(GridItem)
app.use(VanImage)
app.use(Card)
app.use(Tag)
app.use(Cell)
app.use(CellGroup)
app.use(Icon)
app.use(Popup)
app.use(Overlay)
app.use(Loading)
app.use(Toast)
app.use(Dialog)
app.use(ActionSheet)
app.use(Picker)
app.use(Field)
app.use(Form)
app.use(Checkbox)
app.use(CheckboxGroup)
app.use(Radio)
app.use(RadioGroup)
app.use(Stepper)
app.use(Rate)
app.use(Slider)
app.use(Switch)
app.use(Uploader)
app.use(DatetimePicker)
app.use(Calendar)
app.use(Cascader)
app.use(PasswordInput)
app.use(NumberKeyboard)
app.use(Search)
app.use(Tabs)
app.use(Tab)
app.use(Sticky)
app.use(Swipe)
app.use(SwipeItem)
app.use(NoticeBar)
app.use(CountDown)
app.use(Steps)
app.use(Step)
app.use(Divider)
app.use(Empty)
app.use(List)
app.use(PullRefresh)
app.use(BackTop)
app.use(Skeleton)
app.use(SkeletonTitle)
app.use(SkeletonImage)
app.use(SkeletonAvatar)
app.use(SkeletonParagraph)
app.use(Lazyload)
app.use(ImagePreview)
app.use(ShareSheet)
app.use(DropdownMenu)
app.use(DropdownItem)
app.use(Sidebar)
app.use(SidebarItem)
app.use(TreeSelect)
app.use(ContactCard)
app.use(ContactList)
app.use(ContactEdit)
app.use(Area)
app.use(AddressList)
app.use(AddressEdit)
app.use(Goods)
app.use(GoodsAction)
app.use(GoodsActionIcon)
app.use(GoodsActionButton)
app.use(SubmitBar)
app.use(Sku)
app.use(Coupon)
app.use(CouponCell)
app.use(CouponList)

app.use(store).use(router).use(i18n)

// 微信相关配置
if (typeof window !== 'undefined') {
  // 微信 JS-SDK 配置
  window.wxConfig = {
    debug: false,
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'chooseWXPay'
    ]
  }
  
  // 微信分享配置
  window.shareConfig = {
    title: 'Mongolian Beauty Mall',
    desc: 'Focusing on Mongolian costume design, development and promotion',
    link: window.location.href,
    imgUrl: window.location.origin + '/favicon.ico'
  }
}

app.mount('#app')
